import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-career-promoted-content',
  templateUrl: './portal-career-promoted-content.component.html',
  styleUrls: ['./portal-career-promoted-content.component.scss']
})
export class PortalCareerPromotedContent {
  @Input() data: any;
}
